import { render, staticRenderFns } from "./PatternA.vue?vue&type=template&id=61ddbbf3&scoped=true&"
import script from "./PatternA.vue?vue&type=script&lang=js&"
export * from "./PatternA.vue?vue&type=script&lang=js&"
import style0 from "./PatternA.vue?vue&type=style&index=0&id=61ddbbf3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ddbbf3",
  null
  
)

export default component.exports